// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Badge } from 'antd';

const CustomSizeBadge = ({
  width = 6,
  height = 6,
  status = 'default',
  ...props
}) => {

  return <Badge className="custom-size-badge" {...props} status={status} style={{ width: width, height: height }} />;
};

CustomSizeBadge.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  status: PropTypes.string
};
export default CustomSizeBadge;
